import { Button, MenuItem, Select, Stack, TextField } from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DatesPicker from 'src/components/mui/datespicker';
import { boxStyle, MenuFilter, menuStyle } from './MenuStyle';

const MenuOrder = props => {
    const { setFilters, setReload } = props;

    const states = ['신규주문', '주문완료', '신고관리', '배송완료', '주문취소', '취소완료'];
    const payment = ['미결제', '무통장', '계좌이체', '신용카드', 'PG간편결제'];
    const source = ['내부', '견적', '모바일', '일반'];
    const categories = ['화학', '분석', '바이오'];
    const fields = ['국가연구소', '제조업', '학교', '도소매'];
    const locations = ['인천', '서울', '경기'];
    const grades = ['S', 'A', 'B', 'C', 'D', 'E', 'F'];
    const imports = ['중국', '재고', '소모품', '선구매', '기타'];
    const types = ['신규', '기존', '기존신규'];
    
    const [ranges, setRanges] = useState('def');
    const [checkedStates, setCheckedStates] = useState(states);
    const [checkedPay, setCheckedPay] = useState([]);
    const [checkedSrc, setCheckedSrc] = useState(source);
    const [checkedCat, setCheckedCat] = useState(categories);
    const [checkedField, setCheckedField] = useState(fields);
    const [checkedLoc, setCheckedLoc] = useState([]);
    const [checkedGrade, setCheckedGrade] = useState([]);
    const [checkedImport, setCheckedImport] = useState([]);
    const [checkedType, setCheckedType] = useState([]);
    const [keydate, setKeyDate] = useState('order_time');
    const [daterange, setDateRange] = useState({});
    const [keyword, setKeyword] = useState('orderid');
    const [q, setQ] = useState('');

    useEffect(() => {        
        setFilters({
            order_status: checkedStates.join(','),
            source: checkedSrc.join(','),
            business_type: checkedField.join(','),
            prime_address: checkedLoc.join(','),
            membership_level: checkedGrade.join(','),
            import_country: checkedImport.join(','),
            purchase_type: checkedType.join(','),
            keydate: keydate,
            startDate: daterange.startdate? moment(daterange.startdate).format('YYYY-MM-DD 00:00:00'): '',
            endDate: daterange.enddate? moment(daterange.enddate).format('YYYY-MM-DD 23:59:59'): '',
            keyword: keyword,
            q: q,
        });
    }, [checkedStates, checkedSrc, checkedCat, checkedField, checkedLoc, checkedGrade, checkedImport, keydate, daterange, keyword, q]);

    const handleRange = e => {
        setRanges(e.target.dataset.range);
    };

    return (
        <div style={boxStyle}>
            <MenuFilter title={'주문상태'} items={states} checkedItems={checkedStates} setCheckedItems={setCheckedStates} />
            <MenuFilter title={'결제상태'} items={payment} checkedItems={checkedPay} setCheckedItems={setCheckedPay} />
            <MenuFilter title={'주문소스'} items={source} checkedItems={checkedSrc} setCheckedItems={setCheckedSrc} />
            <MenuFilter title={'카테고리'} items={categories} checkedItems={checkedCat} setCheckedItems={setCheckedCat} />
            <MenuFilter title={'업종'} items={fields} checkedItems={checkedField} setCheckedItems={setCheckedField} />
            <MenuFilter title={'지역매출'} items={locations} checkedItems={checkedLoc} setCheckedItems={setCheckedLoc} />
            <MenuFilter title={'회원등급'} items={grades} checkedItems={checkedGrade} setCheckedItems={setCheckedGrade} />
            <MenuFilter title={'수입유형'} items={imports} checkedItems={checkedImport} setCheckedItems={setCheckedImport} />
            <MenuFilter title={'거래유형'} items={types} checkedItems={checkedType} setCheckedItems={setCheckedType} />
            <div style={menuStyle}>
                <h5 style={{ width: '5rem', minWidth: '4rem' }}>검색날짜</h5>
                <Select
                    labelId="target-select-date"
                    id="select-date"
                    value={keydate}
                    onChange={(e) => setKeyDate(e.target.value)}
                    sx={{ minWidth: 120, marginRight: '1rem' }}
                    size='small' >
                        <MenuItem value="order_time">주문일자</MenuItem>
                        <MenuItem value="delivery_date">납기일자</MenuItem>
                        <MenuItem value="warehouse_entry_date">입고일자</MenuItem>
                        <MenuItem value="shipment_date">출고일자</MenuItem>
                </Select>
                <Stack direction="row" spacing={2}>
                    <Button variant="outlined" data-range="today" onClick={handleRange}>오늘</Button>
                    <Button variant="outlined" data-range="yesterday" onClick={handleRange}>어제</Button>
                    <Button variant="outlined" data-range="thisweek" onClick={handleRange}>이번주</Button>
                    <Button variant="outlined" data-range="thismonth" onClick={handleRange}>이번달</Button>
                    <Button variant="outlined" data-range="lastweek" onClick={handleRange}>지난주</Button>
                    <Button variant="outlined" data-range="lastmonth" onClick={handleRange}>지난달</Button>
                    <DatesPicker daterange={daterange} setDateRange={setDateRange} ranges={ranges} size='small' />
                </Stack>
            </div>
            <div style={menuStyle}>
                <h5 style={{ width: '5rem', minWidth: '4rem' }}>검색어</h5>
                <Select
                    labelId="target-select-item"
                    id="select-item"
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    sx={{ minWidth: 120 }}
                    size='small' >
                        <MenuItem value="orderid">주문번호</MenuItem>
                        <MenuItem value="user_id">회원 ID</MenuItem>
                        <MenuItem value="company_name">회사명</MenuItem>
                        <MenuItem value="orderer">주문자</MenuItem>
                        <MenuItem value="catalog_no">Cat No</MenuItem>
                        <MenuItem value="product_name">상품명</MenuItem>
                        <MenuItem value="cas_number">CAS</MenuItem>
                </Select>
                <TextField
                    value={q}
                    label='검색어'
                    id='search'
                    onChange={(e) => setQ(e.target.value)}
                    placeholder='검색어를 입력해주세요'
                    size='small'
                    sx={{ minWidth: 200, marginLeft: '1rem' }}
                />
                <Button variant="contained" onClick={() => setReload(reload => reload+1)} sx={{ marginLeft: '1rem' }}>검색</Button>
            </div>
        </div>
    )
}

export default MenuOrder